module.exports = __webpack_public_path__ + "static/media/mt.02e68159.svg";